import draggable from 'vuedraggable'
export default function (app) {
    app.component('Draggable', draggable)
}
  